import React, { useEffect, useState } from 'react'
import { useDividendAccruedList } from './hooks'
import { ColumnsType } from 'antd/lib/table'
import { DividendAccrued } from './types'
import { CCardBody } from '@coreui/react-pro'
import { Table } from 'antd'
import { getNumberFormat } from '../../../../../../libs/utils'

export const DividendAccruedList: React.FC = () => {
  const { dividendAccruedList, loading, onChangeDividendAccruedList } =
    useDividendAccruedList()

  const [orderBy, setOrderBy] = useState('id')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
  }

  useEffect(() => {
    onChangeDividendAccruedList({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
    })
  }, [pageSize, page, orderBy, orderDirection])

  const columns: ColumnsType<DividendAccrued> = [
    {
      title: 'Operation ID',
      dataIndex: 'dividendAccruedId',
      sorter: (a, b) => a.dividendAccruedId - b.dividendAccruedId,
      defaultSortOrder: 'descend',
    },
    {
      title: 'Date and time',
      dataIndex: 'date',
    },
    {
      title: 'Property ID',
      dataIndex: 'propertyId',
    },
    {
      title: 'Tokens',
      dataIndex: 'tokens',
      render: (item: string) => <div>{getNumberFormat(item, 0)}</div>,
    },
    {
      title: 'Dividend type',
      dataIndex: 'dividendType',
    },
    {
      title: 'Annual %',
      dataIndex: 'annual',
    },
    {
      title: 'GROSS Amount USD',
      dataIndex: 'amountGross',
    },
    {
      title: 'Fees Amount USD',
      dataIndex: 'amountFees',
    },
    {
      title: 'NET Amount USD',
      dataIndex: 'amountNet',
    },
  ]

  return (
    <CCardBody>
      <Table
        dataSource={dividendAccruedList}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="competionsId"
        columns={columns}
        pagination={false}
        onChange={(pagination, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      />
    </CCardBody>
  )
}
